module.exports = __webpack_public_path__ + "static/media/fez.419ba07d.jpg";